import { Badge, Group, Tabs, Tooltip } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import dayjs from "dayjs";

export default function DayTabs({
  days,
  eventDates,
  selectedDay,
  sessionCountByDay,
  onChange,
}) {
  return (
    <Tabs value={selectedDay} onChange={onChange} keepMounted={false}>
      <Tabs.List>
        {days.map((day) => (
          <Tabs.Tab
            key={day}
            value={day}
            rightSection={
              <Group gap={4} wrap="nowrap">
                {eventDates.length > 0 && !eventDates.includes(day) && (
                  <Tooltip label="This day is not in the event dates">
                    <IconAlertTriangle
                      size={14}
                      color="var(--mantine-color-red-6)"
                    />
                  </Tooltip>
                )}
                <Badge size="sm" variant="light">
                  {sessionCountByDay.get(day) ?? 0}
                </Badge>
              </Group>
            }
          >
            {dayjs(day).format("ddd, MMM D")}
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  );
}
